/** Plusvalía % = (valor actual − costo total) / costo total × 100 */
export function computePlusvaliaPct(
  costoTotal: number,
  valorActual: number | null | undefined,
): number | null {
  const cost = Number(costoTotal);
  const current = Number(valorActual);
  if (!Number.isFinite(cost) || cost <= 0) return null;
  if (!Number.isFinite(current)) return null;
  return Math.round(((current - cost) / cost) * 10000) / 100;
}

export function formatPlusvaliaPct(pct: number | null): string {
  if (pct == null || !Number.isFinite(pct)) return '—';
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
}

export function formatPropertyMoney(value: number | null | undefined): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
